import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import styles from '../Path/Path.module.css';

const Software = (props) => {
  const { formatMessage } = useIntl();

  const { config } = useSelector(state => state.config);

  const {
    selectedSoftware,
    setSelectedSoftware,
    inputKey,
  } = props;

  if (!config?.software || config.software.length === 0) {
    return null;
  }

  const updateSoftware = (software, state) => {
    const newList = selectedSoftware.filter(ss => ss.type !== software.type);
    if (state) {
      setSelectedSoftware([...newList, software]);
    } else {
      setSelectedSoftware(newList);
    }
  };

  return (
    <>
      <div className={styles.hr} />
      <div className={styles['options-group']}>
        <div className={`${styles['options-group_title']} Rubik-40pt`}>
          {formatMessage({id: 'OptionsGroup.softwareTitle'})}
        </div>
        <div className={styles.options}>
          {
            config?.software?.map((software, i) => {
              const includedItem = selectedSoftware.find(ss => ss.type === software.type);
              return (
                <div className={`
                    ${styles['option-wrapper_checkbox']}
                    ${Boolean(includedItem) ? styles['option_active'] : ''}
                  `}
                  key={`software-${i}`}
                >
                  <div className={styles['checkbox']}>
                    <input
                      type="checkbox"
                      name={`radio-${inputKey}`}
                      value={software.type}
                      checked={Boolean(includedItem)}
                      onChange={(e) => updateSoftware(software, e.target.checked)}
                      id={`software-${inputKey}-${software.type}`}
                    />
                    <label htmlFor={`software-${inputKey}-${software.type}`}></label>
                  </div>
                  <div className={styles['option-texts']}>
                    <div className={`
                        ${styles['option-title']}
                        Rubik-26pt
                      `}>
                      {software.title}
                    </div>
                    <div className={`
                      ${styles['option-description']}
                      Rubik-20pt`}
                    >
                      { software.description }
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </>
  );
};

export default Software;
